import moment from 'moment';

export class Filter {
  assetClassId: any[] = [];
  assetId: any[] = [];
  assetMakeId: any[] = [];
  assetModelId: any[] = [];
  buId: any[] = [];
  capacityId: any[] = [];
  clusterId: any[] = [];
  endDateTime: any = new Date();
  cmpId: any[] = [];
  icId: any[] = [];
  jobId: any[] = [];
  sbgId: any[] = [];
  oemId: any[] = [];
  availableManualId: any[] = [];
  documentTypeId: any[] = [];
  docNum: any[] = [];
  vehicleTypeId: any[] = [];
  vehicleNumId: any[] = [];
  weighmentTypeId: any[] = [];
  materialCatId: any[] = [];
  materialId: any[] = [];
  vendorId: any[] = [];
  moduleId!: any;
  reportId!: any;
  AssetCodeSelection: any[] = [];
  alertTypeId: any[] = [];
  startDateTime: any = new Date();
  userId: string = '';
  DateTime: { startDate: any; endDate: any } = {
    startDate: moment().startOf('month'),
    endDate: moment().set('hours', 23).set('minutes', 59).set('seconds', 59),
  };
  selectedReport: any;

  constructor(userId: string) {
    this.userId = userId;
  }
}
